import classNames from "classnames/bind";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import { Icon } from "../../../../types/prodcatBaseTypes";
import styles from "./DescriptionIcons.module.scss";

const cx = classNames.bind(styles);

type Props = {
  icons: Icon[];
  isInDrawer?: boolean;
};

export const DescriptionIcons = ({ icons, isInDrawer = false }: Props) => {
  if (icons.length === 0) return null;

  const iconListStyle = cx(styles.icons, {
    isInDrawer,
  });

  return (
    <ul data-testid="description:icons" className={iconListStyle}>
      {icons.map(({ text, iconUrl, linkUrl }) => (
        <li key={iconUrl} className={styles.icon}>
          {linkUrl ? (
            <a
              className={styles.link}
              data-testid="description:icons:link"
              href={linkUrl}
            >
              <IconDetails text={text} iconUrl={iconUrl} />
            </a>
          ) : (
            <IconDetails text={text} iconUrl={iconUrl} />
          )}
        </li>
      ))}
    </ul>
  );
};

function IconDetails({ text, iconUrl }: { text: string; iconUrl: string }) {
  return (
    <>
      <img
        className={styles.image}
        data-testid="description:icons:image"
        src={formatAmplienceImageURL(iconUrl)}
        alt="an icon"
      />
      <span className={styles.text} data-testid="description:icons:text">
        {text}
      </span>
    </>
  );
}
